import { useState } from "react";
import ArticleCard from "./ArticleCard";

const PAGE_SIZE = 6;

export default function ResourcesSection({ id, label, desc, articles, alt, isAdmin }) {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(articles.length / PAGE_SIZE));
  const current = Math.min(page, totalPages);
  const start = (current - 1) * PAGE_SIZE;
  const visible = articles.slice(start, start + PAGE_SIZE);

  const goTo = (p) => {
    setPage(p);
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 68;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section
      id={id}
      style={{
        backgroundColor: alt ? "#F7F7F7" : "#fff",
        padding: "clamp(48px, 6vw, 80px) clamp(20px, 5vw, 80px)",
        scrollMarginTop: 68,
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ marginBottom: 32 }}>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#888", marginBottom: 8, marginTop: 0 }}>{label}</p>
          <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(24px, 3vw, 34px)", letterSpacing: "-0.02em", color: "#1A1A1A", margin: "0 0 10px" }}>{desc}</h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 28 }} className="resources-grid">
          {visible.map((a, i) => (
            <ArticleCard key={start + i} article={a} isAdmin={isAdmin} />
          ))}
        </div>
        {totalPages > 1 && (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 8, marginTop: 40, flexWrap: "wrap" }}>
            <button
              onClick={() => goTo(current - 1)}
              disabled={current === 1}
              style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 600, color: current === 1 ? "#CCC" : "#1A1A1A", background: "#fff", border: "1px solid #E5E5E5", borderRadius: 8, padding: "8px 16px", cursor: current === 1 ? "default" : "pointer" }}
            >
              ← Prev
            </button>
            {Array.from({ length: totalPages }).map((_, i) => (
              <button
                key={i}
                onClick={() => goTo(i + 1)}
                style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 600, color: current === i + 1 ? "#fff" : "#1A1A1A", background: current === i + 1 ? "#112215" : "#fff", border: "1px solid " + (current === i + 1 ? "#1A1A1A" : "#E5E5E5"), borderRadius: 8, padding: "8px 14px", minWidth: 40, cursor: "pointer" }}
              >
                {i + 1}
              </button>
            ))}
            <button
              onClick={() => goTo(current + 1)}
              disabled={current === totalPages}
              style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 600, color: current === totalPages ? "#CCC" : "#1A1A1A", background: "#fff", border: "1px solid #E5E5E5", borderRadius: 8, padding: "8px 16px", cursor: current === totalPages ? "default" : "pointer" }}
            >
              Next →
            </button>
          </div>
        )}
      </div>
      <style>{`
        @media (max-width: 768px) { .resources-grid { grid-template-columns: 1fr !important; } }
        @media (min-width: 769px) and (max-width: 1000px) { .resources-grid { grid-template-columns: repeat(2, 1fr) !important; } }
      `}</style>
    </section>
  );
}